module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/main-categories-icons/25-082e4d0cabce442011affb1a7aa9ed1d.svg";